import { render, staticRenderFns } from "./senstityWord.vue?vue&type=template&id=1e41c190&"
import script from "./senstityWord.vue?vue&type=script&lang=js&"
export * from "./senstityWord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e41c190')) {
      api.createRecord('1e41c190', component.options)
    } else {
      api.reload('1e41c190', component.options)
    }
    module.hot.accept("./senstityWord.vue?vue&type=template&id=1e41c190&", function () {
      api.rerender('1e41c190', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/senstityWord.vue"
export default component.exports